/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PaginatedMaintenanceResponse = {
    properties: {
        data: {
    type: 'array',
    contains: {
        type: 'MaintenanceRequestResponse',
    },
    isRequired: true,
},
        total: {
    type: 'number',
    isRequired: true,
},
        limit: {
    type: 'number',
    isRequired: true,
},
        offset: {
    type: 'number',
    isRequired: true,
},
        hasMore: {
    type: 'boolean',
    isRequired: true,
},
        isMaintenance: {
    type: 'boolean',
},
    },
};